import { ProductType as t, VariantType as p } from "@ancon/wildcat-types";
function r({
  product: e
}) {
  return e.productType === t.PrepaidWallet && e.variantType === p.CardTopUp;
}
export {
  r as default
};
